export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
